module.exports = __webpack_public_path__ + "mobile/img/icon_tabbar_home_center.87032479.png";